import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

const url = `${apiUrl}traits`;

export const traitsGet = (jobId) =>
    axios.get(`${url}/job?jobId=${jobId}`);

export const traitInsert = (data) =>
    axios.post(`${url}/job`, data);

export const traitUpdate = (id, data) =>
    axios.put(`${url}/job/${id}`, data);

export const traitDelete = (id) =>
    axios.delete(`${url}/job/${id}`);

export const storeTraitsGet = (storeId, jobId) =>
    axios.get(`${url}/store/${storeId}/job/${jobId}`);

export const storeTraitsDelete = (id) =>
    axios.delete(`${url}/store/${id}`);

export const storeTraitInsert = (data) =>
    axios.post(`${url}/store`, data);
